import { ShieldStarIcon } from '@c/icons';
import BaseModal from './BaseModal';

interface ProtectionPolicyModalProps {
  isOpen: boolean;
  dismiss: () => void;
  content?: string;
}

const PROTECTION_POLICY_HTML = `<h3 class="text-[1.5rem] font-bold">Your purchase is protected.</h3>
<p>If your item is lost in transit, arrives damaged, or isn&rsquo;t as described, you get a full refund.</p>
<p>&nbsp;</p>
<h3 class="text-[1.5rem] font-bold">How It Works</h3>
<ol>
<li><strong>Message the seller</strong> within 48 hours of delivery with photos or video of the issue.</li>
<li><strong>Contact us</strong> at <a class="text-brand-secondary hover:text-brand-primary" href="mailto:support@gearfocus.com"><strong>support@gearfocus.com</strong></a> if the seller doesn&rsquo;t respond within 24 hours.</li>
<li><strong>We handle it</strong> &mdash; GearFocus reviews the case and processes your refund.</li>
</ol>
<p>Item never arrived? Skip step 1 &mdash; email <a class="text-brand-secondary hover:text-brand-primary" href="mailto:support@gearfocus.com"><strong>support@gearfocus.com</strong></a> within 14 days of the expected delivery date and we&rsquo;ll take it from there.</p>
<p>&nbsp;</p>
<h3 class="text-[1.5rem] font-bold">What&rsquo;s Covered</h3>
<p>To be covered, orders must be completed through GearFocus (payment and shipping) and issues reported within 48 hours of delivery or within 14 days of the expected delivery date if undelivered.</p>
<p>You qualify for a full refund if your item is:</p>
<ul>
<li>Lost in transit or never delivered</li>
<li>Damaged during shipping</li>
<li>Significantly different from the listing description or photos</li>
</ul>
<p>&nbsp;</p>
<h3 class="text-[1.5rem] font-bold">Seller Return Policies</h3>
<p>Each listing includes a return policy set by the seller &mdash; check it before you buy. Every listing includes a 48-hour verification period so you can confirm the item matches the description.</p>
<p>&nbsp;</p>
<p>Orders must be completed through GearFocus (payment and shipping) to qualify for protection.</p>
<p>&nbsp;</p>
<p><a class="text-brand-secondary hover:text-brand-primary font-semibold" href="/policies/buyer-protection">Read the full Buyer Protection Policy &rarr;</a></p>`;

const ProtectionPolicyModal: React.FC<ProtectionPolicyModalProps> = ({
  isOpen,
  dismiss,
  content,
}) => {
  return (
    <BaseModal
      isOpen={isOpen}
      dismiss={dismiss}
      title={
        <div className="flex items-center gap-[0.8rem] font-semibold text-brand-secondary">
          <ShieldStarIcon />
          GearFocus Buyer Protection
        </div>
      }
      overflowType="auto"
      width="50rem"
    >
      <div
        dangerouslySetInnerHTML={{ __html: content ?? PROTECTION_POLICY_HTML }}
      />
    </BaseModal>
  );
};

export default ProtectionPolicyModal;
